"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncludedAsStandardWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var services_1 = require("@falcon/services");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../commonFunctions");
var DocumentListModal_1 = require("../annual/motor/DocumentListModal");
var IncludedAsStandardWidget = exports.IncludedAsStandardWidget = /** @class */ (function (_super) {
    __extends(IncludedAsStandardWidget, _super);
    function IncludedAsStandardWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IncludedAsStandardWidget.prototype.render = function () {
        var _a, _b, _c;
        var showViewDocumentsText = this.getSetting("showViewDocumentsText");
        var showPolicyDocumentLink = this.getSetting("showPolicyDocumentLink");
        var COVER_TYPE;
        (function (COVER_TYPE) {
            COVER_TYPE["MOTOR_LEGAL_EXPENSES"] = "MOTOR_LEGAL_EXPENSES";
            COVER_TYPE["GUARANTEED_HIRE_CAR"] = "GUARANTEED_HIRE_CAR";
            COVER_TYPE["EUROPEAN_COVER"] = "EUROPEAN_COVER";
            COVER_TYPE["WINDSCREEN_COVER"] = "WINDSCREEN_COVER";
            COVER_TYPE["CHILD_CAR_SEAT_REPLACEMENT"] = "CHILD_CAR_SEAT_REPLACEMENT";
            COVER_TYPE["PERSONAL_ACCIDENT_COVER"] = "PERSONAL_ACCIDENT_COVER";
        })(COVER_TYPE || (COVER_TYPE = {}));
        var includedCovers = {
            ALLIANZ: (_a = {},
                _a[COVER_TYPE.MOTOR_LEGAL_EXPENSES] = {
                    heading: "Motor Legal Expenses",
                    details: React.createElement(React.Fragment, null,
                        "Cover for up to ",
                        React.createElement("strong", null, (0, commonFunctions_1.getAmountToDisplay)(100000)),
                        " in legal costs if you\u2019re in an accident that\u2019s not your fault."),
                    enabled: true,
                },
                _a[COVER_TYPE.GUARANTEED_HIRE_CAR] = {
                    heading: "Guaranteed hire car if your car’s stolen or being repaired.",
                    details: "We'll provide you with a small hatchback for as long as your car takes to repair after an accident or up to 21 days if it's stolen or not repairable.",
                    enabled: true,
                },
                _a[COVER_TYPE.EUROPEAN_COVER] = {
                    heading: "European cover",
                    details: "Get covered in Europe for up to 180 days a year at the same level as your UK cover. Ole!",
                    enabled: true,
                },
                _a[COVER_TYPE.WINDSCREEN_COVER] = {
                    heading: "Windscreen cover",
                    details: "Covers all the glass on your car. Where possible we repair rather than replace. Excess applies.",
                    enabled: true,
                },
                _a[COVER_TYPE.CHILD_CAR_SEAT_REPLACEMENT] = {
                    heading: "Child car seat replacement",
                    details: "We cover your child seats after a theft, accident or fire – even if there’s no sign of damage. Excess applies.",
                    enabled: true,
                },
                _a),
            ALLIANZ_SILVER: (_b = {},
                _b[COVER_TYPE.GUARANTEED_HIRE_CAR] = {
                    heading: "Guaranteed hire car while yours is being repaired",
                    details: "We’ll provide you with a small hatchback for as long as your car takes to repair after an accident.",
                    enabled: true,
                },
                _b[COVER_TYPE.EUROPEAN_COVER] = {
                    heading: "European cover",
                    details: "Cover in Europe for up to 90 days a year at the same level as your UK cover. Ole!",
                    enabled: true,
                },
                _b[COVER_TYPE.WINDSCREEN_COVER] = {
                    heading: "Windscreen cover",
                    details: "Covers all the glass on your car. Where possible we repair rather than replace. Excess applies.",
                    enabled: true,
                },
                _b[COVER_TYPE.CHILD_CAR_SEAT_REPLACEMENT] = {
                    heading: "Child car seat replacement",
                    details: "We cover your child seats after a theft, accident or fire – even if there’s no sign of damage. Excess applies",
                    enabled: true,
                },
                _b[COVER_TYPE.PERSONAL_ACCIDENT_COVER] = {
                    heading: "Personal accident cover",
                    details: React.createElement(React.Fragment, null,
                        "We\u2019ll pay a lump sum of ",
                        React.createElement("strong", null, (0, commonFunctions_1.getAmountToDisplay)(5000)),
                        " if you, your partner or a named driver have a serious injury such as loss or total loss of use of a limb, loss of sight or hearing, total disablement, or injuries resulting in death when travelling in or getting in or out of your car."),
                    enabled: true,
                },
                _b),
            ALLIANZ_ESSENTIALS: (_c = {},
                _c[COVER_TYPE.WINDSCREEN_COVER] = {
                    heading: "Windscreen cover",
                    details: "Covers all the glass on your car. Where possible we repair rather than replace. Excess applies.",
                    enabled: true,
                },
                _c[COVER_TYPE.CHILD_CAR_SEAT_REPLACEMENT] = {
                    heading: "Child car seat replacement",
                    details: "We cover your child seats after a theft, accident or fire – even if there’s no sign of damage. Excess applies.",
                    enabled: true,
                },
                _c[COVER_TYPE.PERSONAL_ACCIDENT_COVER] = {
                    heading: "Personal accident cover",
                    details: React.createElement(React.Fragment, null,
                        "We'll pay a lump sum of up to",
                        React.createElement("strong", null,
                            " ",
                            (0, commonFunctions_1.getAmountToDisplay)((1000)),
                            " "),
                        "if you, your partner or a named driver have a serious injury such as loss or total loss of a limb, loss of sight or hearing, total disablement, or injuries resulting in death when travelling in or getting in or out of your car."),
                    enabled: this.showPersonalAccidentCover(),
                },
                _c),
        };
        return (React.createElement("div", { className: "included-standard-section" },
            React.createElement("div", null,
                React.createElement("h3", { className: "font-weight-semi-bold mb-0 padding-bottom-32" },
                    "A quick reminder of some of the cover included",
                    (this.props.interaction.coverTier === services_1.ALLIANZ_ESSENTIALS || this.props.interaction.coverTier === services_1.ALLIANZ_SILVER) && "..."),
                showViewDocumentsText && React.createElement("p", null, "View full details in the policy documents below."),
                React.createElement("div", null, this.renderIncludedCovers(includedCovers[this.props.interaction.coverTier])),
                this.props.interaction.coverTier === services_1.ALLIANZ && showPolicyDocumentLink && this.renderPolicyDocumentSection(),
                this.props.interaction.coverTier === services_1.ALLIANZ_ESSENTIALS && this.renderNotIncluded())));
    };
    IncludedAsStandardWidget.prototype.renderNotIncluded = function () {
        return (React.createElement("div", { className: "padding-top-32" },
            React.createElement("h3", { className: "font-weight-semi-bold mb-0 padding-bottom-32" }, "...and what isn\u2019t"),
            React.createElement("div", { className: "media mb-0" },
                React.createElement("span", { className: "wolf-red-cross" }),
                React.createElement("div", null,
                    React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0" }, "Driving other cars"),
                    React.createElement("div", { className: "font-weight-light" }, "The policyholder and named drivers won\u2019t be covered when driving other cars.")))));
    };
    IncludedAsStandardWidget.prototype.renderIncludedCovers = function (tierIncludedCovers) {
        var _this = this;
        return (React.createElement(React.Fragment, null, Object.entries(tierIncludedCovers).map(function (_a) {
            var _ = _a[0], data = _a[1];
            return (data && _this.renderCover(data.heading, data.details));
        })));
    };
    IncludedAsStandardWidget.prototype.renderCover = function (heading, details) {
        return (React.createElement("div", { className: "media mb-3" },
            React.createElement("span", { className: "wolf-green-tick" }),
            React.createElement("div", null,
                React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0" }, heading),
                React.createElement("div", { className: "font-weight-light" }, details))));
    };
    IncludedAsStandardWidget.prototype.renderPolicyDocumentSection = function () {
        var documentVersion = (0, DocumentListModal_1.getDocumentVersionByDate)(new Date(this.props.interaction.factors.originalQuoteDate));
        return (React.createElement("div", { className: "mt-5 mb-5" },
            React.createElement("p", null,
                "Open the ",
                React.createElement("a", { className: "link", target: "_blank", download: "Allianz Car Document of Insurance (DOI)", href: "/resources/documents/LV_Allianz_Annual_Car/".concat(documentVersion, "/LV_Allianz_Annual_Car_DOI_").concat(documentVersion, ".pdf") }, "policy document"),
                " to see full cover details")));
    };
    IncludedAsStandardWidget.prototype.showPersonalAccidentCover = function () {
        var _a, _b, _c;
        var policyStartDate = (_b = (_a = this.props.interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : (_c = this.props.interaction.uistate) === null || _c === void 0 ? void 0 : _c.policyPeriodStartDate;
        return (!(0, commonFunctions_1.isBeforeIntroductionOfPersonalAccidentCover)(policyStartDate));
    };
    IncludedAsStandardWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showViewDocumentsText", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "showPolicyDocumentLink", type: journey_model_1.TypeDescriptions.Boolean }
        ])
    ], IncludedAsStandardWidget);
    return IncludedAsStandardWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=IncludedAsStandardWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/IncludedAsStandardWidget.js
// module id = 3229
// module chunks = 0